/** =========================================================
 * Workgroups controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-workgroups')
    .controller('WorkgroupsController', WorkgroupsController);

  WorkgroupsController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams'
  ];

  function WorkgroupsController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page workgroups',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'workgroup',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: [{
            users: ['id', 'name']
          }, {
            order_task_types: ['workgroup_id', 'id', 'name']
          }]
        },
        filters: angular.copy($stateParams.filters),
        resources: ['user'],
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Users',
          key: null,
          value: function (item) {
            return item.users.map(function (user) {
              return user.name;
            }).join(', ');
          }
        }, {
          title: 'Order task types',
          key: null,
          value: function (item) {
            return item.order_task_types.map(function (type) {
              return type.name;
            }).join(', ');
          }
        }],
        add: {
          template: 'app/views/dialogs/item-workgroup.html'
        },
        edit: {
          template: 'app/views/dialogs/item-workgroup.html',
          except: ['order_task_types']
        },
        delete: {}
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
